module.exports = "<ng-container *ngIf=\"if_condition\">\n  <span class=\"note__span\">{{structure['default_value'] | translate}}</span>\n</ng-container>\n"